const obj = {
    isObject(it) {
        return (it && typeof it === 'object' && !Array.isArray(it));
    },

    objEqual(a, b, path = '', ignoreKeys = []) {
        if (a === b) return [];

        if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) {
            return [`Различие в ${path || 'корень'}: ${a} !== ${b}`];
        }

        const differences = [];
        const keys = new Set([...Object.keys(a), ...Object.keys(b)]);

        for (const key of keys) {
            if (ignoreKeys.includes(key)) continue;

            const newPath = path ? `${path}.${key}` : key;

            if (!(key in a)) {
                differences.push(`Ключ ${newPath} есть только во втором объекте`);
            } else if (!(key in b)) {
                differences.push(`Ключ ${newPath} есть только в первом объекте`);
            } else {
                differences.push(...this.objEqual(a[key], b[key], newPath, ignoreKeys));
            }
        }

        return differences;
    },

    isObjectsEqual(a, b, ignoreKeys = []) {
        return this.objEqual(a, b, '', ignoreKeys).length === 0;
    }

};

export default obj;
